import React, { useState } from 'react';
import {
  Box, TextField, Button, Typography, CircularProgress, Paper,
  FormControl, InputLabel, Select, MenuItem, Stack
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { useVans, useCreateLoad } from './loads.hooks';

import { useNavigate } from 'react-router-dom';
export default function CreateLoadPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    datetime: '',
    vanid: '',
    file: null,
  });

  const { data: vans = [], isLoading, isError, error } = useVans();

  const {
    mutate,
    isLoading: isSubmitting,
  } = useCreateLoad(
    () => {
      dispatch(showAlert({ severity: 'success', title: 'Load created successfully!' }));
      navigate('/loads/manage');
    },
    (error) => {
      dispatch(showAlert({
        severity: 'error',
        title: error?.response?.data?.message || 'Something went wrong'
      }));
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Allow both .xls and .xlsx
    const isExcel =
      (file.name.endsWith('.xls') && file.type === 'application/vnd.ms-excel') ||
      (file.name.endsWith('.xlsx') &&
        (file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type === 'application/octet-stream')); // some browsers use octet-stream
  
    if (!isExcel) {
      dispatch(
        showAlert({
        severity: 'error',
          title: 'Only .xls or .xlsx files are allowed.',
        })
      );
      return;
    }

    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      dispatch(
        showAlert({
        severity: 'error',
        title: 'File size must be less than 2MB.',
        })
      );
      return;
    }

    setFormData((prev) => ({ ...prev, file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    mutate(formData);
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 500, mx: 'auto', mt: 6 }}>
      <Typography variant="h5" gutterBottom>Create Load</Typography>

      {isLoading && <CircularProgress />}
      {isError && dispatch(showAlert({ severity: 'error', title: error.message }))}

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Stack spacing={3}>
          <TextField
            label="Load Date"
            name="datetime"
            type="date"
            value={formData.datetime}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
            required
          />

          <FormControl fullWidth required>
            <InputLabel id="van-label">Select Van</InputLabel>
            <Select
              labelId="van-label"
              name="vanid"
              value={formData.vanid}
              label="Select Van"
              onChange={handleChange}
            >
              {vans.map((van) => (
                <MenuItem key={van.id} value={van.id}>
                  {van.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button variant="outlined" component="label">
  Upload .xls / .xlsx File
            <input
              type="file"
              hidden
    accept=".xls,.xlsx"
              onChange={handleFileChange}
            />
          </Button>

          {formData.file && (
            <Typography variant="body2">
              Selected File: {formData.file.name}
            </Typography>
          )}

          <Button type="submit" variant="contained" fullWidth disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={24} /> : 'Submit Load'}
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}
